import { authInputClassName, authSecondaryClassName } from '../constants/styles'

import { useAuthContext } from '@/features/auth/contexts/AuthContext'

import { AuthShell } from './AuthShell'
import { ForgotPasswordButton } from './ForgotPassword/Button'
import { ForgotPasswordFields } from './ForgotPassword/Fields'
import { ForgotPasswordForm } from './ForgotPassword/Form'

interface ForgotPasswordProps {
  onSuccess?: () => void
}

export const ForgotPassword = ({ onSuccess: _onSuccess }: ForgotPasswordProps) => {
  const { setAction } = useAuthContext()

  return (
    <AuthShell
      title="Esqueceu sua senha?"
      subtitle="Enviaremos um código para você redefini-la"
    >
      <ForgotPasswordForm className="flex flex-col gap-4">
        <ForgotPasswordFields inputClassName={authInputClassName} />
        <ForgotPasswordButton>Resetar Senha</ForgotPasswordButton>
        <button
          type="button"
          className={authSecondaryClassName}
          onClick={() => setAction('sign-in')}
        >
          Cancelar
        </button>
      </ForgotPasswordForm>
    </AuthShell>
  )
}
